package com.vizio.redwolf.consent.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

object ConsentMessageFormat {
    const val TEXT = "text"
    const val HTML_CSS = "html+css"
}

@Serializable
data class UserConsentV2DataRequestInfo(
    val consentIds: List<String>,
    val consentGroupIds: List<String>,
    val acceptLanguage: String,
    val consentMessageFormat: String,
    val expand: Boolean
)

@Serializable
data class ConsentV2DataRequestBody(
    val consentIds: List<String>,
    val consentGroupIds: List<String>
)

@Serializable
data class SaveUserConsentV2RequestBody(
    val userId: String,
    val userIdType: String,
    val consentIdsActions: ConsentAction,
    val consentGroupIdsActions: ConsentGroupAction,
    val consentToken: String
)

@Serializable
data class UserConsentV2StatusRequestBody(
    val userId: String,
    val userIdType: String,
    val consentIds: List<String>,
    val consentGroupIds: List<String>
)

@Serializable
data class ConsentAction(
    @SerialName("ACCEPT") val acceptList: List<String>,
    @SerialName("REJECT") val rejectList: List<String>,
)

@Serializable
data class ConsentGroupAction(
    @SerialName("ACCEPT") val acceptList: List<String>,
    @SerialName("REJECT") val rejectList: List<String>,
)
